import { render, staticRenderFns } from "./PageSecurity.vue?vue&type=template&id=25ae32e6&scoped=true&"
import script from "./PageSecurity.vue?vue&type=script&lang=js&"
export * from "./PageSecurity.vue?vue&type=script&lang=js&"
import style0 from "../../styles/content-page.css?vue&type=style&index=0&id=25ae32e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ae32e6",
  null
  
)

export default component.exports